import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { ToggleSwitch } from '@/components/ui/toggle-switch'
import { useDesignVersionToggle } from '@/hooks'

import PropertyManagersList from './PropertyManagersList'
import PropertyManagerForm from './PropertyManagerForm'

// TODO: remove this legacy master/detail page (and the Redux propertyManagers consumers it feeds) once the new design is fully rolled out
const PropertyManagersPage = () => {
  const { t } = useTranslation(['organisation'])
  const navigate = useNavigate()
  const params = useParams()

  const { redirect, toggle: handleUIToggle } = useDesignVersionToggle({
    group: 'property-managers',
    screen: 'PropertyManagers',
    to: { path: '/dashboard/organisation/property-managers' },
    version: 'legacy',
  })

  if (redirect) return redirect

  return (
    <div className="columns">
      <div className="ctp-organisation__design-toggle">
        <ToggleSwitch
          falsyLabel={t('organisation:propertyManagers.list.designToggle.old')}
          truthyLabel={t('organisation:propertyManagers.list.designToggle.new')}
          checked={false}
          onChange={handleUIToggle}
        />
      </div>
      <div className="column">
        <div className="ctp-short-toolbar-wrapper">
          <button
            className="button button-primary"
            onClick={() => navigate('/dashboard/organisation/property-managers/legacy/new')}
          >
            {t('organisation:shared.actions.addNew')}
          </button>
        </div>
        <PropertyManagersList />
      </div>
      <div className="column">
        <PropertyManagerForm params={params} />
      </div>
    </div>
  )
}

export default PropertyManagersPage
